// types
import { useEffect, useState } from 'react';
import {
  SelectComponentTypes,
  SelectItemProps,
  SelectListPosition,
  SelectType,
} from './types';

// components
import IconSelected from '../icons/selected';
import IconLoader from '../icons/loader';
import styles from './select.module.css';
import IconSearch from '../icons/search';

let searchTimeout: NodeJS.Timeout;

export default function OptionsList({
  list,
  handleSelectValue,
  selectValues,
  selectListPosition,
  isLoading,
  emptyContentButton,
  ulRef,
  onScroll,
  mode,
  nextPageIsLoading,
  onSearch,
}: SelectComponentTypes): React.JSX.Element {
  let isFirefox = false;
  const { userAgent } = navigator;

  if (userAgent.indexOf('Firefox') !== -1) {
    isFirefox = true;
  }

  const [filteredList, setFilteredList] = useState<
    SelectItemProps[] | undefined
  >(undefined);
  const [searchText, setSearchText] = useState('');

  const onSearchAction = (text: string) => {
    setSearchText(text);

    clearTimeout(searchTimeout);

    if (onSearch) {
      searchTimeout = setTimeout(() => {
        onSearch(text);
      }, 700);
    } else {
      setFilteredList(
        list?.filter((item) =>
          item.name.toLowerCase()?.includes(text?.toLowerCase()),
        ),
      );
    }
  };

  useEffect(() => {
    if (!filteredList) {
      setFilteredList(list);
    }
  }, [list]);

  return (
    <ul
      className={`${styles.selectList} ${
        selectListPosition === SelectListPosition.BOTTOM
          ? styles.bottomPosition
          : styles.topPosition
      } ${isLoading && !nextPageIsLoading ? styles.listOverflowHidden : ''}`}
      role="menu"
      ref={ulRef}
      onScroll={onScroll}
      style={isFirefox ? { scrollbarWidth: 'thin' } : undefined}
    >
      {mode === SelectType.MULTIPLE && (
        <div className={styles.multipleSearchInputWrapper}>
          <IconSearch />
          <input
            type="text"
            name="searchInput"
            className={styles.multipleSearchInput}
            placeholder="Search value..."
            onChange={(e) => onSearchAction(e.target.value)}
            value={searchText}
            disabled={isLoading && !nextPageIsLoading}
          />
        </div>
      )}
      {isLoading && !nextPageIsLoading && (
        <li
          className={`${styles.listLoader} ${mode === SelectType.MULTIPLE ? styles.multipleListLoader : ''}`}
        >
          <IconLoader />
        </li>
      )}
      {(!isLoading || (isLoading && nextPageIsLoading)) && (
        <>
          {filteredList?.length ? (
            filteredList?.map((item: SelectItemProps) => (
              <li
                key={item.value.toString()}
                role="menuitem"
                className={`select-item ${
                  selectValues?.find(
                    (selectedItem) =>
                      selectedItem.toString() === item.value.toString(),
                  )
                    ? styles.selected
                    : ''
                }`}
              >
                <button
                  type="button"
                  onClick={() => handleSelectValue(item)}
                  tabIndex={-1}
                >
                  <div
                    className={`${styles.selectItemItemTop} ${
                      !item.description ? styles.fullWidth : ''
                    }`}
                  >
                    <span>{item.name}</span>

                    <span className="select-item-top-right">
                      <span>{item.suffix || ''}</span>
                      {selectValues?.find(
                        (selected) =>
                          selected.toString() === item.value.toString(),
                      ) && <IconSelected />}
                    </span>
                  </div>
                  {item.description && (
                    <div className={styles.description}>{item.description}</div>
                  )}
                </button>
              </li>
            ))
          ) : (
            <>
              <li role="menuitem">
                <div className={styles.emptyListItem}>Not found</div>
              </li>
              {emptyContentButton && (
                <li role="menuitem">{emptyContentButton}</li>
              )}
            </>
          )}
        </>
      )}

      {nextPageIsLoading && (
        <li className={styles.nextPageLoader}>
          <IconLoader />
        </li>
      )}
    </ul>
  );
}
